/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AttemptAnswerDto } from '../models';
// @ts-ignore
import type { AttemptDetailsDto } from '../models';
// @ts-ignore
import type { AttemptDto } from '../models';
// @ts-ignore
import type { AttemptEventNewDto } from '../models';
// @ts-ignore
import type { AttemptModeDto } from '../models';
// @ts-ignore
import type { AttemptPageDto } from '../models';
// @ts-ignore
import type { AttemptReasonDto } from '../models';
// @ts-ignore
import type { AttemptRefusalDto } from '../models';
// @ts-ignore
import type { AttemptStartDto } from '../models';
// @ts-ignore
import type { AttemptStartedDto } from '../models';
// @ts-ignore
import type { AttemptStatusDto } from '../models';
// @ts-ignore
import type { AttemptTimelineDto } from '../models';
// @ts-ignore
import type { ConflictProblemDto } from '../models';
// @ts-ignore
import type { ProblemDetailDto } from '../models';
// @ts-ignore
import type { TestRefusalDto } from '../models';
/**
 * AttemptsApi - axios parameter creator
 * @export
 */
export const AttemptsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Saved at once, so a closed browser or a power cut loses nothing. The answer has the shape of the question: chosenAnswerIds for a single choice (exactly one) and a multiple choice (one or more), order for putting answers in order (every answer once), typed for an answer typed in. A test that does not let the person go back takes the questions in order, each answer final: only the first question still without an answer can be answered. Answers are taken until the deadline, with a few seconds for one already on its way.
         * @summary Answer a question, or change the answer
         * @param {string} attemptId 
         * @param {number} index The place of the question in the attempt, counted from 1.
         * @param {string} xAttemptKey The key the start of the attempt answered with. It opens this attempt and nothing else; the person taking a test has no session. Sent in a header, never in an address, so it stays out of logs and of anything a page links to.
         * @param {AttemptAnswerDto} attemptAnswerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        answerAttemptQuestion: async (attemptId: string, index: number, xAttemptKey: string, attemptAnswerDto: AttemptAnswerDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attemptId' is not null or undefined
            assertParamExists('answerAttemptQuestion', 'attemptId', attemptId)
            // verify required parameter 'index' is not null or undefined
            assertParamExists('answerAttemptQuestion', 'index', index)
            // verify required parameter 'xAttemptKey' is not null or undefined
            assertParamExists('answerAttemptQuestion', 'xAttemptKey', xAttemptKey)
            // verify required parameter 'attemptAnswerDto' is not null or undefined
            assertParamExists('answerAttemptQuestion', 'attemptAnswerDto', attemptAnswerDto)
            const localVarPath = `/api/v1/attempts/{attemptId}/answers/{index}`
                .replace(`{${"attemptId"}}`, encodeURIComponent(String(attemptId)))
                .replace(`{${"index"}}`, encodeURIComponent(String(index)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xAttemptKey != null) {
                localVarHeaderParameter['X-Attempt-Key'] = String(xAttemptKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(attemptAnswerDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The end of the attempt for its screen: the key stops working, and every call with it answers 403 — the screen cannot be brought back to the questions or to the right answers. Only an attempt that is over closes.
         * @summary Close the screen of the result
         * @param {string} attemptId 
         * @param {string} xAttemptKey The key the start of the attempt answered with. It opens this attempt and nothing else; the person taking a test has no session. Sent in a header, never in an address, so it stays out of logs and of anything a page links to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeAttempt: async (attemptId: string, xAttemptKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attemptId' is not null or undefined
            assertParamExists('closeAttempt', 'attemptId', attemptId)
            // verify required parameter 'xAttemptKey' is not null or undefined
            assertParamExists('closeAttempt', 'xAttemptKey', xAttemptKey)
            const localVarPath = `/api/v1/attempts/{attemptId}/close`
                .replace(`{${"attemptId"}}`, encodeURIComponent(String(attemptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAttemptKey != null) {
                localVarHeaderParameter['X-Attempt-Key'] = String(xAttemptKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Only with every question answered — the one way out without a full set is the time running out, which the server takes care of itself. The answer carries the result, and the mistakes when the test shows them. An attempt already over is returned as it is.
         * @summary Finish the attempt
         * @param {string} attemptId 
         * @param {string} xAttemptKey The key the start of the attempt answered with. It opens this attempt and nothing else; the person taking a test has no session. Sent in a header, never in an address, so it stays out of logs and of anything a page links to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishAttempt: async (attemptId: string, xAttemptKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attemptId' is not null or undefined
            assertParamExists('finishAttempt', 'attemptId', attemptId)
            // verify required parameter 'xAttemptKey' is not null or undefined
            assertParamExists('finishAttempt', 'xAttemptKey', xAttemptKey)
            const localVarPath = `/api/v1/attempts/{attemptId}/finish`
                .replace(`{${"attemptId"}}`, encodeURIComponent(String(attemptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAttemptKey != null) {
                localVarHeaderParameter['X-Attempt-Key'] = String(xAttemptKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Every question in the order asked, in the language of the attempt, with the answers in the order drawn and what the person has answered so far. Nothing here gives away an answer: no correctness, no points, no explanation, no expected answers. Pictures and films come as links that work for a few minutes; ask for the attempt again for fresh ones, as the screen does when it shows a question. Time is the server\'s: the deadline and the server\'s clock come together, so the screen can count down without trusting its own.
         * @summary The attempt as the person taking it sees it
         * @param {string} attemptId 
         * @param {string} xAttemptKey The key the start of the attempt answered with. It opens this attempt and nothing else; the person taking a test has no session. Sent in a header, never in an address, so it stays out of logs and of anything a page links to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttempt: async (attemptId: string, xAttemptKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attemptId' is not null or undefined
            assertParamExists('getAttempt', 'attemptId', attemptId)
            // verify required parameter 'xAttemptKey' is not null or undefined
            assertParamExists('getAttempt', 'xAttemptKey', xAttemptKey)
            const localVarPath = `/api/v1/attempts/{attemptId}`
                .replace(`{${"attemptId"}}`, encodeURIComponent(String(attemptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xAttemptKey != null) {
                localVarHeaderParameter['X-Attempt-Key'] = String(xAttemptKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For whoever runs the test, never for the person taking it — a session opens this, not the key. Every question as drawn: the version and the order of options the person saw, in the same shape as a sample draw, so the question preview shows it; then the answer given and when, the points it earned, and the settings of the test at the start. For an exam, the grade of each question instead of an answer — the topics asked, the mark, the decision or the points, the comment, who and when — and who finished it. The comments are for whoever runs exams, never for the person examined.
         * @summary An attempt as it was taken, with the answer key
         * @param {string} attemptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttemptDetails: async (attemptId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attemptId' is not null or undefined
            assertParamExists('getAttemptDetails', 'attemptId', attemptId)
            const localVarPath = `/api/v1/attempts/{attemptId}/details`
                .replace(`{${"attemptId"}}`, encodeURIComponent(String(attemptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For whoever runs the test, with a session. The start, every answer and every change of an answer, the events of the screen, the grades of an exam and every change of a grade, the end and the closing of the result — each with the server\'s time, the earliest first.
         * @summary Everything that happened in an attempt, in order
         * @param {string} attemptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttemptTimeline: async (attemptId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attemptId' is not null or undefined
            assertParamExists('getAttemptTimeline', 'attemptId', attemptId)
            const localVarPath = `/api/v1/attempts/{attemptId}/timeline`
                .replace(`{${"attemptId"}}`, encodeURIComponent(String(attemptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * For an attempt broken off for technical or chance reasons — a failure, a fire, a flooded shop. One in progress ends at once: its screen sees INVALIDATED and saves nothing more. An invalidated attempt counts neither towards the limit nor as a pass, but stays in the history with who invalidated it, when and why; its number does not change, and its score, if it had one, stays as it was. With a session, never with the key of the attempt.
         * @summary Invalidate an attempt that should not count
         * @param {string} attemptId 
         * @param {AttemptReasonDto} attemptReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invalidateAttempt: async (attemptId: string, attemptReasonDto: AttemptReasonDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attemptId' is not null or undefined
            assertParamExists('invalidateAttempt', 'attemptId', attemptId)
            // verify required parameter 'attemptReasonDto' is not null or undefined
            assertParamExists('invalidateAttempt', 'attemptReasonDto', attemptReasonDto)
            const localVarPath = `/api/v1/attempts/{attemptId}/invalidate`
                .replace(`{${"attemptId"}}`, encodeURIComponent(String(attemptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(attemptReasonDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Who took which test, when, and with what result once it was over. Newest first unless asked otherwise. Opened with a session, never with the key of an attempt. For the administrator for now; scopes by shop and region come with permissions.
         * @summary Attempts at tests, for whoever runs them
         * @param {string} [testId] 
         * @param {string} [sapNumber] The person, by the SAP number exactly.
         * @param {AttemptStatusDto} [status] 
         * @param {AttemptModeDto} [mode] Tests taken on a screen, or exams an examiner ran; absent for both.
         * @param {boolean} [passed] true for the attempts that passed, false for those that did not; an attempt in progress, an invalidated one, or one at a test without a threshold is neither.
         * @param {string} [startedFrom] Started on this day or later.
         * @param {string} [startedTo] Started on this day or earlier, the whole day counted.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sort] Field and direction — startedAt or percent — for example \&quot;percent,asc\&quot;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAttempts: async (testId?: string, sapNumber?: string, status?: AttemptStatusDto, mode?: AttemptModeDto, passed?: boolean, startedFrom?: string, startedTo?: string, page?: number, size?: number, sort?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/attempts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (testId !== undefined) {
                localVarQueryParameter['testId'] = testId;
            }

            if (sapNumber !== undefined) {
                localVarQueryParameter['sapNumber'] = sapNumber;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (mode !== undefined) {
                localVarQueryParameter['mode'] = mode;
            }

            if (passed !== undefined) {
                localVarQueryParameter['passed'] = passed;
            }

            if (startedFrom !== undefined) {
                localVarQueryParameter['startedFrom'] = (startedFrom as any instanceof Date) ?
                    (startedFrom as any).toISOString().substring(0,10) :
                    startedFrom;
            }

            if (startedTo !== undefined) {
                localVarQueryParameter['startedTo'] = (startedTo as any instanceof Date) ?
                    (startedTo as any).toISOString().substring(0,10) :
                    startedTo;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The screen records, it never blocks: the window losing focus and getting it back, the tab hidden and shown, full screen left, PrintScreen, a copy, a paste, the context menu, and which question was opened. One event a call, sent as it happens; the time is the server\'s, not the browser\'s. Taken only while the attempt runs. The log keeps the first 1000 events of an attempt; past them a call still answers 204 and records nothing.
         * @summary Record what happened on the screen of the test
         * @param {string} attemptId 
         * @param {string} xAttemptKey The key the start of the attempt answered with. It opens this attempt and nothing else; the person taking a test has no session. Sent in a header, never in an address, so it stays out of logs and of anything a page links to.
         * @param {AttemptEventNewDto} attemptEventNewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordAttemptEvent: async (attemptId: string, xAttemptKey: string, attemptEventNewDto: AttemptEventNewDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attemptId' is not null or undefined
            assertParamExists('recordAttemptEvent', 'attemptId', attemptId)
            // verify required parameter 'xAttemptKey' is not null or undefined
            assertParamExists('recordAttemptEvent', 'xAttemptKey', xAttemptKey)
            // verify required parameter 'attemptEventNewDto' is not null or undefined
            assertParamExists('recordAttemptEvent', 'attemptEventNewDto', attemptEventNewDto)
            const localVarPath = `/api/v1/attempts/{attemptId}/events`
                .replace(`{${"attemptId"}}`, encodeURIComponent(String(attemptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xAttemptKey != null) {
                localVarHeaderParameter['X-Attempt-Key'] = String(xAttemptKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(attemptEventNewDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Started from the panel by whoever runs the test — an administrator for now, a manager in the shop later. The person taking it does not sign in: the answer carries a key, once, and the screen of the test sends it with every call that follows. The questions are drawn now, as the sample draw draws them, for the position the person takes the test for, and are frozen with the version and the order of answers the person sees; later changes to the bank or to the test do not touch the attempt.
         * @summary Start an attempt at an active test for a named person
         * @param {string} testId 
         * @param {AttemptStartDto} attemptStartDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startAttempt: async (testId: string, attemptStartDto: AttemptStartDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('startAttempt', 'testId', testId)
            // verify required parameter 'attemptStartDto' is not null or undefined
            assertParamExists('startAttempt', 'attemptStartDto', attemptStartDto)
            const localVarPath = `/api/v1/tests/{testId}/attempts`
                .replace(`{${"testId"}}`, encodeURIComponent(String(testId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(attemptStartDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AttemptsApi - functional programming interface
 * @export
 */
export const AttemptsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AttemptsApiAxiosParamCreator(configuration)
    return {
        /**
         * Saved at once, so a closed browser or a power cut loses nothing. The answer has the shape of the question: chosenAnswerIds for a single choice (exactly one) and a multiple choice (one or more), order for putting answers in order (every answer once), typed for an answer typed in. A test that does not let the person go back takes the questions in order, each answer final: only the first question still without an answer can be answered. Answers are taken until the deadline, with a few seconds for one already on its way.
         * @summary Answer a question, or change the answer
         * @param {string} attemptId 
         * @param {number} index The place of the question in the attempt, counted from 1.
         * @param {string} xAttemptKey The key the start of the attempt answered with. It opens this attempt and nothing else; the person taking a test has no session. Sent in a header, never in an address, so it stays out of logs and of anything a page links to.
         * @param {AttemptAnswerDto} attemptAnswerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async answerAttemptQuestion(attemptId: string, index: number, xAttemptKey: string, attemptAnswerDto: AttemptAnswerDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.answerAttemptQuestion(attemptId, index, xAttemptKey, attemptAnswerDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttemptsApi.answerAttemptQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The end of the attempt for its screen: the key stops working, and every call with it answers 403 — the screen cannot be brought back to the questions or to the right answers. Only an attempt that is over closes.
         * @summary Close the screen of the result
         * @param {string} attemptId 
         * @param {string} xAttemptKey The key the start of the attempt answered with. It opens this attempt and nothing else; the person taking a test has no session. Sent in a header, never in an address, so it stays out of logs and of anything a page links to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async closeAttempt(attemptId: string, xAttemptKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.closeAttempt(attemptId, xAttemptKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttemptsApi.closeAttempt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Only with every question answered — the one way out without a full set is the time running out, which the server takes care of itself. The answer carries the result, and the mistakes when the test shows them. An attempt already over is returned as it is.
         * @summary Finish the attempt
         * @param {string} attemptId 
         * @param {string} xAttemptKey The key the start of the attempt answered with. It opens this attempt and nothing else; the person taking a test has no session. Sent in a header, never in an address, so it stays out of logs and of anything a page links to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async finishAttempt(attemptId: string, xAttemptKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttemptDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.finishAttempt(attemptId, xAttemptKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttemptsApi.finishAttempt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Every question in the order asked, in the language of the attempt, with the answers in the order drawn and what the person has answered so far. Nothing here gives away an answer: no correctness, no points, no explanation, no expected answers. Pictures and films come as links that work for a few minutes; ask for the attempt again for fresh ones, as the screen does when it shows a question. Time is the server\'s: the deadline and the server\'s clock come together, so the screen can count down without trusting its own.
         * @summary The attempt as the person taking it sees it
         * @param {string} attemptId 
         * @param {string} xAttemptKey The key the start of the attempt answered with. It opens this attempt and nothing else; the person taking a test has no session. Sent in a header, never in an address, so it stays out of logs and of anything a page links to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAttempt(attemptId: string, xAttemptKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttemptDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAttempt(attemptId, xAttemptKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttemptsApi.getAttempt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * For whoever runs the test, never for the person taking it — a session opens this, not the key. Every question as drawn: the version and the order of options the person saw, in the same shape as a sample draw, so the question preview shows it; then the answer given and when, the points it earned, and the settings of the test at the start. For an exam, the grade of each question instead of an answer — the topics asked, the mark, the decision or the points, the comment, who and when — and who finished it. The comments are for whoever runs exams, never for the person examined.
         * @summary An attempt as it was taken, with the answer key
         * @param {string} attemptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAttemptDetails(attemptId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttemptDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAttemptDetails(attemptId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttemptsApi.getAttemptDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * For whoever runs the test, with a session. The start, every answer and every change of an answer, the events of the screen, the grades of an exam and every change of a grade, the end and the closing of the result — each with the server\'s time, the earliest first.
         * @summary Everything that happened in an attempt, in order
         * @param {string} attemptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAttemptTimeline(attemptId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttemptTimelineDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAttemptTimeline(attemptId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttemptsApi.getAttemptTimeline']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * For an attempt broken off for technical or chance reasons — a failure, a fire, a flooded shop. One in progress ends at once: its screen sees INVALIDATED and saves nothing more. An invalidated attempt counts neither towards the limit nor as a pass, but stays in the history with who invalidated it, when and why; its number does not change, and its score, if it had one, stays as it was. With a session, never with the key of the attempt.
         * @summary Invalidate an attempt that should not count
         * @param {string} attemptId 
         * @param {AttemptReasonDto} attemptReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invalidateAttempt(attemptId: string, attemptReasonDto: AttemptReasonDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invalidateAttempt(attemptId, attemptReasonDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttemptsApi.invalidateAttempt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Who took which test, when, and with what result once it was over. Newest first unless asked otherwise. Opened with a session, never with the key of an attempt. For the administrator for now; scopes by shop and region come with permissions.
         * @summary Attempts at tests, for whoever runs them
         * @param {string} [testId] 
         * @param {string} [sapNumber] The person, by the SAP number exactly.
         * @param {AttemptStatusDto} [status] 
         * @param {AttemptModeDto} [mode] Tests taken on a screen, or exams an examiner ran; absent for both.
         * @param {boolean} [passed] true for the attempts that passed, false for those that did not; an attempt in progress, an invalidated one, or one at a test without a threshold is neither.
         * @param {string} [startedFrom] Started on this day or later.
         * @param {string} [startedTo] Started on this day or earlier, the whole day counted.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sort] Field and direction — startedAt or percent — for example \&quot;percent,asc\&quot;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAttempts(testId?: string, sapNumber?: string, status?: AttemptStatusDto, mode?: AttemptModeDto, passed?: boolean, startedFrom?: string, startedTo?: string, page?: number, size?: number, sort?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttemptPageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAttempts(testId, sapNumber, status, mode, passed, startedFrom, startedTo, page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttemptsApi.listAttempts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The screen records, it never blocks: the window losing focus and getting it back, the tab hidden and shown, full screen left, PrintScreen, a copy, a paste, the context menu, and which question was opened. One event a call, sent as it happens; the time is the server\'s, not the browser\'s. Taken only while the attempt runs. The log keeps the first 1000 events of an attempt; past them a call still answers 204 and records nothing.
         * @summary Record what happened on the screen of the test
         * @param {string} attemptId 
         * @param {string} xAttemptKey The key the start of the attempt answered with. It opens this attempt and nothing else; the person taking a test has no session. Sent in a header, never in an address, so it stays out of logs and of anything a page links to.
         * @param {AttemptEventNewDto} attemptEventNewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recordAttemptEvent(attemptId: string, xAttemptKey: string, attemptEventNewDto: AttemptEventNewDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recordAttemptEvent(attemptId, xAttemptKey, attemptEventNewDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttemptsApi.recordAttemptEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Started from the panel by whoever runs the test — an administrator for now, a manager in the shop later. The person taking it does not sign in: the answer carries a key, once, and the screen of the test sends it with every call that follows. The questions are drawn now, as the sample draw draws them, for the position the person takes the test for, and are frozen with the version and the order of answers the person sees; later changes to the bank or to the test do not touch the attempt.
         * @summary Start an attempt at an active test for a named person
         * @param {string} testId 
         * @param {AttemptStartDto} attemptStartDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startAttempt(testId: string, attemptStartDto: AttemptStartDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttemptStartedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startAttempt(testId, attemptStartDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttemptsApi.startAttempt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AttemptsApi - factory interface
 * @export
 */
export const AttemptsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AttemptsApiFp(configuration)
    return {
        /**
         * Saved at once, so a closed browser or a power cut loses nothing. The answer has the shape of the question: chosenAnswerIds for a single choice (exactly one) and a multiple choice (one or more), order for putting answers in order (every answer once), typed for an answer typed in. A test that does not let the person go back takes the questions in order, each answer final: only the first question still without an answer can be answered. Answers are taken until the deadline, with a few seconds for one already on its way.
         * @summary Answer a question, or change the answer
         * @param {string} attemptId 
         * @param {number} index The place of the question in the attempt, counted from 1.
         * @param {string} xAttemptKey The key the start of the attempt answered with. It opens this attempt and nothing else; the person taking a test has no session. Sent in a header, never in an address, so it stays out of logs and of anything a page links to.
         * @param {AttemptAnswerDto} attemptAnswerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        answerAttemptQuestion(attemptId: string, index: number, xAttemptKey: string, attemptAnswerDto: AttemptAnswerDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.answerAttemptQuestion(attemptId, index, xAttemptKey, attemptAnswerDto, options).then((request) => request(axios, basePath));
        },
        /**
         * The end of the attempt for its screen: the key stops working, and every call with it answers 403 — the screen cannot be brought back to the questions or to the right answers. Only an attempt that is over closes.
         * @summary Close the screen of the result
         * @param {string} attemptId 
         * @param {string} xAttemptKey The key the start of the attempt answered with. It opens this attempt and nothing else; the person taking a test has no session. Sent in a header, never in an address, so it stays out of logs and of anything a page links to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeAttempt(attemptId: string, xAttemptKey: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.closeAttempt(attemptId, xAttemptKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Only with every question answered — the one way out without a full set is the time running out, which the server takes care of itself. The answer carries the result, and the mistakes when the test shows them. An attempt already over is returned as it is.
         * @summary Finish the attempt
         * @param {string} attemptId 
         * @param {string} xAttemptKey The key the start of the attempt answered with. It opens this attempt and nothing else; the person taking a test has no session. Sent in a header, never in an address, so it stays out of logs and of anything a page links to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishAttempt(attemptId: string, xAttemptKey: string, options?: RawAxiosRequestConfig): AxiosPromise<AttemptDto> {
            return localVarFp.finishAttempt(attemptId, xAttemptKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Every question in the order asked, in the language of the attempt, with the answers in the order drawn and what the person has answered so far. Nothing here gives away an answer: no correctness, no points, no explanation, no expected answers. Pictures and films come as links that work for a few minutes; ask for the attempt again for fresh ones, as the screen does when it shows a question. Time is the server\'s: the deadline and the server\'s clock come together, so the screen can count down without trusting its own.
         * @summary The attempt as the person taking it sees it
         * @param {string} attemptId 
         * @param {string} xAttemptKey The key the start of the attempt answered with. It opens this attempt and nothing else; the person taking a test has no session. Sent in a header, never in an address, so it stays out of logs and of anything a page links to.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttempt(attemptId: string, xAttemptKey: string, options?: RawAxiosRequestConfig): AxiosPromise<AttemptDto> {
            return localVarFp.getAttempt(attemptId, xAttemptKey, options).then((request) => request(axios, basePath));
        },
        /**
         * For whoever runs the test, never for the person taking it — a session opens this, not the key. Every question as drawn: the version and the order of options the person saw, in the same shape as a sample draw, so the question preview shows it; then the answer given and when, the points it earned, and the settings of the test at the start. For an exam, the grade of each question instead of an answer — the topics asked, the mark, the decision or the points, the comment, who and when — and who finished it. The comments are for whoever runs exams, never for the person examined.
         * @summary An attempt as it was taken, with the answer key
         * @param {string} attemptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttemptDetails(attemptId: string, options?: RawAxiosRequestConfig): AxiosPromise<AttemptDetailsDto> {
            return localVarFp.getAttemptDetails(attemptId, options).then((request) => request(axios, basePath));
        },
        /**
         * For whoever runs the test, with a session. The start, every answer and every change of an answer, the events of the screen, the grades of an exam and every change of a grade, the end and the closing of the result — each with the server\'s time, the earliest first.
         * @summary Everything that happened in an attempt, in order
         * @param {string} attemptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttemptTimeline(attemptId: string, options?: RawAxiosRequestConfig): AxiosPromise<AttemptTimelineDto> {
            return localVarFp.getAttemptTimeline(attemptId, options).then((request) => request(axios, basePath));
        },
        /**
         * For an attempt broken off for technical or chance reasons — a failure, a fire, a flooded shop. One in progress ends at once: its screen sees INVALIDATED and saves nothing more. An invalidated attempt counts neither towards the limit nor as a pass, but stays in the history with who invalidated it, when and why; its number does not change, and its score, if it had one, stays as it was. With a session, never with the key of the attempt.
         * @summary Invalidate an attempt that should not count
         * @param {string} attemptId 
         * @param {AttemptReasonDto} attemptReasonDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invalidateAttempt(attemptId: string, attemptReasonDto: AttemptReasonDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.invalidateAttempt(attemptId, attemptReasonDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Who took which test, when, and with what result once it was over. Newest first unless asked otherwise. Opened with a session, never with the key of an attempt. For the administrator for now; scopes by shop and region come with permissions.
         * @summary Attempts at tests, for whoever runs them
         * @param {string} [testId] 
         * @param {string} [sapNumber] The person, by the SAP number exactly.
         * @param {AttemptStatusDto} [status] 
         * @param {AttemptModeDto} [mode] Tests taken on a screen, or exams an examiner ran; absent for both.
         * @param {boolean} [passed] true for the attempts that passed, false for those that did not; an attempt in progress, an invalidated one, or one at a test without a threshold is neither.
         * @param {string} [startedFrom] Started on this day or later.
         * @param {string} [startedTo] Started on this day or earlier, the whole day counted.
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [sort] Field and direction — startedAt or percent — for example \&quot;percent,asc\&quot;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAttempts(testId?: string, sapNumber?: string, status?: AttemptStatusDto, mode?: AttemptModeDto, passed?: boolean, startedFrom?: string, startedTo?: string, page?: number, size?: number, sort?: string, options?: RawAxiosRequestConfig): AxiosPromise<AttemptPageDto> {
            return localVarFp.listAttempts(testId, sapNumber, status, mode, passed, startedFrom, startedTo, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * The screen records, it never blocks: the window losing focus and getting it back, the tab hidden and shown, full screen left, PrintScreen, a copy, a paste, the context menu, and which question was opened. One event a call, sent as it happens; the time is the server\'s, not the browser\'s. Taken only while the attempt runs. The log keeps the first 1000 events of an attempt; past them a call still answers 204 and records nothing.
         * @summary Record what happened on the screen of the test
         * @param {string} attemptId 
         * @param {string} xAttemptKey The key the start of the attempt answered with. It opens this attempt and nothing else; the person taking a test has no session. Sent in a header, never in an address, so it stays out of logs and of anything a page links to.
         * @param {AttemptEventNewDto} attemptEventNewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordAttemptEvent(attemptId: string, xAttemptKey: string, attemptEventNewDto: AttemptEventNewDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.recordAttemptEvent(attemptId, xAttemptKey, attemptEventNewDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Started from the panel by whoever runs the test — an administrator for now, a manager in the shop later. The person taking it does not sign in: the answer carries a key, once, and the screen of the test sends it with every call that follows. The questions are drawn now, as the sample draw draws them, for the position the person takes the test for, and are frozen with the version and the order of answers the person sees; later changes to the bank or to the test do not touch the attempt.
         * @summary Start an attempt at an active test for a named person
         * @param {string} testId 
         * @param {AttemptStartDto} attemptStartDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startAttempt(testId: string, attemptStartDto: AttemptStartDto, options?: RawAxiosRequestConfig): AxiosPromise<AttemptStartedDto> {
            return localVarFp.startAttempt(testId, attemptStartDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AttemptsApi - interface
 * @export
 * @interface AttemptsApi
 */
export interface AttemptsApiInterface {
    /**
     * Saved at once, so a closed browser or a power cut loses nothing. The answer has the shape of the question: chosenAnswerIds for a single choice (exactly one) and a multiple choice (one or more), order for putting answers in order (every answer once), typed for an answer typed in. A test that does not let the person go back takes the questions in order, each answer final: only the first question still without an answer can be answered. Answers are taken until the deadline, with a few seconds for one already on its way.
     * @summary Answer a question, or change the answer
     * @param {string} attemptId 
     * @param {number} index The place of the question in the attempt, counted from 1.
     * @param {string} xAttemptKey The key the start of the attempt answered with. It opens this attempt and nothing else; the person taking a test has no session. Sent in a header, never in an address, so it stays out of logs and of anything a page links to.
     * @param {AttemptAnswerDto} attemptAnswerDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttemptsApiInterface
     */
    answerAttemptQuestion(attemptId: string, index: number, xAttemptKey: string, attemptAnswerDto: AttemptAnswerDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * The end of the attempt for its screen: the key stops working, and every call with it answers 403 — the screen cannot be brought back to the questions or to the right answers. Only an attempt that is over closes.
     * @summary Close the screen of the result
     * @param {string} attemptId 
     * @param {string} xAttemptKey The key the start of the attempt answered with. It opens this attempt and nothing else; the person taking a test has no session. Sent in a header, never in an address, so it stays out of logs and of anything a page links to.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttemptsApiInterface
     */
    closeAttempt(attemptId: string, xAttemptKey: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Only with every question answered — the one way out without a full set is the time running out, which the server takes care of itself. The answer carries the result, and the mistakes when the test shows them. An attempt already over is returned as it is.
     * @summary Finish the attempt
     * @param {string} attemptId 
     * @param {string} xAttemptKey The key the start of the attempt answered with. It opens this attempt and nothing else; the person taking a test has no session. Sent in a header, never in an address, so it stays out of logs and of anything a page links to.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttemptsApiInterface
     */
    finishAttempt(attemptId: string, xAttemptKey: string, options?: RawAxiosRequestConfig): AxiosPromise<AttemptDto>;

    /**
     * Every question in the order asked, in the language of the attempt, with the answers in the order drawn and what the person has answered so far. Nothing here gives away an answer: no correctness, no points, no explanation, no expected answers. Pictures and films come as links that work for a few minutes; ask for the attempt again for fresh ones, as the screen does when it shows a question. Time is the server\'s: the deadline and the server\'s clock come together, so the screen can count down without trusting its own.
     * @summary The attempt as the person taking it sees it
     * @param {string} attemptId 
     * @param {string} xAttemptKey The key the start of the attempt answered with. It opens this attempt and nothing else; the person taking a test has no session. Sent in a header, never in an address, so it stays out of logs and of anything a page links to.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttemptsApiInterface
     */
    getAttempt(attemptId: string, xAttemptKey: string, options?: RawAxiosRequestConfig): AxiosPromise<AttemptDto>;

    /**
     * For whoever runs the test, never for the person taking it — a session opens this, not the key. Every question as drawn: the version and the order of options the person saw, in the same shape as a sample draw, so the question preview shows it; then the answer given and when, the points it earned, and the settings of the test at the start. For an exam, the grade of each question instead of an answer — the topics asked, the mark, the decision or the points, the comment, who and when — and who finished it. The comments are for whoever runs exams, never for the person examined.
     * @summary An attempt as it was taken, with the answer key
     * @param {string} attemptId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttemptsApiInterface
     */
    getAttemptDetails(attemptId: string, options?: RawAxiosRequestConfig): AxiosPromise<AttemptDetailsDto>;

    /**
     * For whoever runs the test, with a session. The start, every answer and every change of an answer, the events of the screen, the grades of an exam and every change of a grade, the end and the closing of the result — each with the server\'s time, the earliest first.
     * @summary Everything that happened in an attempt, in order
     * @param {string} attemptId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttemptsApiInterface
     */
    getAttemptTimeline(attemptId: string, options?: RawAxiosRequestConfig): AxiosPromise<AttemptTimelineDto>;

    /**
     * For an attempt broken off for technical or chance reasons — a failure, a fire, a flooded shop. One in progress ends at once: its screen sees INVALIDATED and saves nothing more. An invalidated attempt counts neither towards the limit nor as a pass, but stays in the history with who invalidated it, when and why; its number does not change, and its score, if it had one, stays as it was. With a session, never with the key of the attempt.
     * @summary Invalidate an attempt that should not count
     * @param {string} attemptId 
     * @param {AttemptReasonDto} attemptReasonDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttemptsApiInterface
     */
    invalidateAttempt(attemptId: string, attemptReasonDto: AttemptReasonDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Who took which test, when, and with what result once it was over. Newest first unless asked otherwise. Opened with a session, never with the key of an attempt. For the administrator for now; scopes by shop and region come with permissions.
     * @summary Attempts at tests, for whoever runs them
     * @param {string} [testId] 
     * @param {string} [sapNumber] The person, by the SAP number exactly.
     * @param {AttemptStatusDto} [status] 
     * @param {AttemptModeDto} [mode] Tests taken on a screen, or exams an examiner ran; absent for both.
     * @param {boolean} [passed] true for the attempts that passed, false for those that did not; an attempt in progress, an invalidated one, or one at a test without a threshold is neither.
     * @param {string} [startedFrom] Started on this day or later.
     * @param {string} [startedTo] Started on this day or earlier, the whole day counted.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sort] Field and direction — startedAt or percent — for example \&quot;percent,asc\&quot;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttemptsApiInterface
     */
    listAttempts(testId?: string, sapNumber?: string, status?: AttemptStatusDto, mode?: AttemptModeDto, passed?: boolean, startedFrom?: string, startedTo?: string, page?: number, size?: number, sort?: string, options?: RawAxiosRequestConfig): AxiosPromise<AttemptPageDto>;

    /**
     * The screen records, it never blocks: the window losing focus and getting it back, the tab hidden and shown, full screen left, PrintScreen, a copy, a paste, the context menu, and which question was opened. One event a call, sent as it happens; the time is the server\'s, not the browser\'s. Taken only while the attempt runs. The log keeps the first 1000 events of an attempt; past them a call still answers 204 and records nothing.
     * @summary Record what happened on the screen of the test
     * @param {string} attemptId 
     * @param {string} xAttemptKey The key the start of the attempt answered with. It opens this attempt and nothing else; the person taking a test has no session. Sent in a header, never in an address, so it stays out of logs and of anything a page links to.
     * @param {AttemptEventNewDto} attemptEventNewDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttemptsApiInterface
     */
    recordAttemptEvent(attemptId: string, xAttemptKey: string, attemptEventNewDto: AttemptEventNewDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Started from the panel by whoever runs the test — an administrator for now, a manager in the shop later. The person taking it does not sign in: the answer carries a key, once, and the screen of the test sends it with every call that follows. The questions are drawn now, as the sample draw draws them, for the position the person takes the test for, and are frozen with the version and the order of answers the person sees; later changes to the bank or to the test do not touch the attempt.
     * @summary Start an attempt at an active test for a named person
     * @param {string} testId 
     * @param {AttemptStartDto} attemptStartDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttemptsApiInterface
     */
    startAttempt(testId: string, attemptStartDto: AttemptStartDto, options?: RawAxiosRequestConfig): AxiosPromise<AttemptStartedDto>;

}

/**
 * AttemptsApi - object-oriented interface
 * @export
 * @class AttemptsApi
 * @extends {BaseAPI}
 */
export class AttemptsApi extends BaseAPI implements AttemptsApiInterface {
    /**
     * Saved at once, so a closed browser or a power cut loses nothing. The answer has the shape of the question: chosenAnswerIds for a single choice (exactly one) and a multiple choice (one or more), order for putting answers in order (every answer once), typed for an answer typed in. A test that does not let the person go back takes the questions in order, each answer final: only the first question still without an answer can be answered. Answers are taken until the deadline, with a few seconds for one already on its way.
     * @summary Answer a question, or change the answer
     * @param {string} attemptId 
     * @param {number} index The place of the question in the attempt, counted from 1.
     * @param {string} xAttemptKey The key the start of the attempt answered with. It opens this attempt and nothing else; the person taking a test has no session. Sent in a header, never in an address, so it stays out of logs and of anything a page links to.
     * @param {AttemptAnswerDto} attemptAnswerDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttemptsApi
     */
    public answerAttemptQuestion(attemptId: string, index: number, xAttemptKey: string, attemptAnswerDto: AttemptAnswerDto, options?: RawAxiosRequestConfig) {
        return AttemptsApiFp(this.configuration).answerAttemptQuestion(attemptId, index, xAttemptKey, attemptAnswerDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The end of the attempt for its screen: the key stops working, and every call with it answers 403 — the screen cannot be brought back to the questions or to the right answers. Only an attempt that is over closes.
     * @summary Close the screen of the result
     * @param {string} attemptId 
     * @param {string} xAttemptKey The key the start of the attempt answered with. It opens this attempt and nothing else; the person taking a test has no session. Sent in a header, never in an address, so it stays out of logs and of anything a page links to.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttemptsApi
     */
    public closeAttempt(attemptId: string, xAttemptKey: string, options?: RawAxiosRequestConfig) {
        return AttemptsApiFp(this.configuration).closeAttempt(attemptId, xAttemptKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Only with every question answered — the one way out without a full set is the time running out, which the server takes care of itself. The answer carries the result, and the mistakes when the test shows them. An attempt already over is returned as it is.
     * @summary Finish the attempt
     * @param {string} attemptId 
     * @param {string} xAttemptKey The key the start of the attempt answered with. It opens this attempt and nothing else; the person taking a test has no session. Sent in a header, never in an address, so it stays out of logs and of anything a page links to.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttemptsApi
     */
    public finishAttempt(attemptId: string, xAttemptKey: string, options?: RawAxiosRequestConfig) {
        return AttemptsApiFp(this.configuration).finishAttempt(attemptId, xAttemptKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Every question in the order asked, in the language of the attempt, with the answers in the order drawn and what the person has answered so far. Nothing here gives away an answer: no correctness, no points, no explanation, no expected answers. Pictures and films come as links that work for a few minutes; ask for the attempt again for fresh ones, as the screen does when it shows a question. Time is the server\'s: the deadline and the server\'s clock come together, so the screen can count down without trusting its own.
     * @summary The attempt as the person taking it sees it
     * @param {string} attemptId 
     * @param {string} xAttemptKey The key the start of the attempt answered with. It opens this attempt and nothing else; the person taking a test has no session. Sent in a header, never in an address, so it stays out of logs and of anything a page links to.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttemptsApi
     */
    public getAttempt(attemptId: string, xAttemptKey: string, options?: RawAxiosRequestConfig) {
        return AttemptsApiFp(this.configuration).getAttempt(attemptId, xAttemptKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * For whoever runs the test, never for the person taking it — a session opens this, not the key. Every question as drawn: the version and the order of options the person saw, in the same shape as a sample draw, so the question preview shows it; then the answer given and when, the points it earned, and the settings of the test at the start. For an exam, the grade of each question instead of an answer — the topics asked, the mark, the decision or the points, the comment, who and when — and who finished it. The comments are for whoever runs exams, never for the person examined.
     * @summary An attempt as it was taken, with the answer key
     * @param {string} attemptId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttemptsApi
     */
    public getAttemptDetails(attemptId: string, options?: RawAxiosRequestConfig) {
        return AttemptsApiFp(this.configuration).getAttemptDetails(attemptId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * For whoever runs the test, with a session. The start, every answer and every change of an answer, the events of the screen, the grades of an exam and every change of a grade, the end and the closing of the result — each with the server\'s time, the earliest first.
     * @summary Everything that happened in an attempt, in order
     * @param {string} attemptId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttemptsApi
     */
    public getAttemptTimeline(attemptId: string, options?: RawAxiosRequestConfig) {
        return AttemptsApiFp(this.configuration).getAttemptTimeline(attemptId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * For an attempt broken off for technical or chance reasons — a failure, a fire, a flooded shop. One in progress ends at once: its screen sees INVALIDATED and saves nothing more. An invalidated attempt counts neither towards the limit nor as a pass, but stays in the history with who invalidated it, when and why; its number does not change, and its score, if it had one, stays as it was. With a session, never with the key of the attempt.
     * @summary Invalidate an attempt that should not count
     * @param {string} attemptId 
     * @param {AttemptReasonDto} attemptReasonDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttemptsApi
     */
    public invalidateAttempt(attemptId: string, attemptReasonDto: AttemptReasonDto, options?: RawAxiosRequestConfig) {
        return AttemptsApiFp(this.configuration).invalidateAttempt(attemptId, attemptReasonDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Who took which test, when, and with what result once it was over. Newest first unless asked otherwise. Opened with a session, never with the key of an attempt. For the administrator for now; scopes by shop and region come with permissions.
     * @summary Attempts at tests, for whoever runs them
     * @param {string} [testId] 
     * @param {string} [sapNumber] The person, by the SAP number exactly.
     * @param {AttemptStatusDto} [status] 
     * @param {AttemptModeDto} [mode] Tests taken on a screen, or exams an examiner ran; absent for both.
     * @param {boolean} [passed] true for the attempts that passed, false for those that did not; an attempt in progress, an invalidated one, or one at a test without a threshold is neither.
     * @param {string} [startedFrom] Started on this day or later.
     * @param {string} [startedTo] Started on this day or earlier, the whole day counted.
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sort] Field and direction — startedAt or percent — for example \&quot;percent,asc\&quot;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttemptsApi
     */
    public listAttempts(testId?: string, sapNumber?: string, status?: AttemptStatusDto, mode?: AttemptModeDto, passed?: boolean, startedFrom?: string, startedTo?: string, page?: number, size?: number, sort?: string, options?: RawAxiosRequestConfig) {
        return AttemptsApiFp(this.configuration).listAttempts(testId, sapNumber, status, mode, passed, startedFrom, startedTo, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The screen records, it never blocks: the window losing focus and getting it back, the tab hidden and shown, full screen left, PrintScreen, a copy, a paste, the context menu, and which question was opened. One event a call, sent as it happens; the time is the server\'s, not the browser\'s. Taken only while the attempt runs. The log keeps the first 1000 events of an attempt; past them a call still answers 204 and records nothing.
     * @summary Record what happened on the screen of the test
     * @param {string} attemptId 
     * @param {string} xAttemptKey The key the start of the attempt answered with. It opens this attempt and nothing else; the person taking a test has no session. Sent in a header, never in an address, so it stays out of logs and of anything a page links to.
     * @param {AttemptEventNewDto} attemptEventNewDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttemptsApi
     */
    public recordAttemptEvent(attemptId: string, xAttemptKey: string, attemptEventNewDto: AttemptEventNewDto, options?: RawAxiosRequestConfig) {
        return AttemptsApiFp(this.configuration).recordAttemptEvent(attemptId, xAttemptKey, attemptEventNewDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Started from the panel by whoever runs the test — an administrator for now, a manager in the shop later. The person taking it does not sign in: the answer carries a key, once, and the screen of the test sends it with every call that follows. The questions are drawn now, as the sample draw draws them, for the position the person takes the test for, and are frozen with the version and the order of answers the person sees; later changes to the bank or to the test do not touch the attempt.
     * @summary Start an attempt at an active test for a named person
     * @param {string} testId 
     * @param {AttemptStartDto} attemptStartDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttemptsApi
     */
    public startAttempt(testId: string, attemptStartDto: AttemptStartDto, options?: RawAxiosRequestConfig) {
        return AttemptsApiFp(this.configuration).startAttempt(testId, attemptStartDto, options).then((request) => request(this.axios, this.basePath));
    }
}

